import type { IModalLogoutTranslations } from '@/Contexts/GLModalLogout/types/translations';

const enUS: IModalLogoutTranslations = {
  title: 'Session expired',
  description: 'Your session has expired for security reasons. Click OK to log in again.',
  buttonText: 'Ok',
};

export { enUS };
